import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class GetRegisterdDeviceDetailsUseCase extends BaseUseCase {
    constructor(getRegisterdDeviceRep) {
        super();
        this.getRegisterdDeviceRep = getRegisterdDeviceRep;
    }
    async fetchResult(req) {
        return await this.getRegisterdDeviceRep.getDeviceRegisterDetailsData(req);
    }
}
export default GetRegisterdDeviceDetailsUseCase;
